import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EnvironmentService } from '@core/services/environment/environment.service';
import {
  WorkTool,
  WorkToolRequest,
  WorkToolResponse,
} from '@modules/configurations/domain/models/work-tools.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkToolsService {
  private readonly environment = inject(EnvironmentService);
  private readonly http = inject(HttpClient);

  private readonly API_URL = this.environment.getApiUrl();

  getWorkTools(subUserId?: number, activate_only = false): Observable<WorkToolResponse> {
    const headers = subUserId ? new HttpHeaders({ 'x-sub-userid': String(subUserId) }) : undefined;
    return this.http.get<WorkToolResponse>(`${this.API_URL}v1/work-tools/`, {
      headers,
      params: { active_only: String(activate_only) },
    });
  }

  createWorkTool(tool: WorkToolRequest): Observable<WorkTool> {
    return this.http.post<WorkTool>(`${this.API_URL}v1/work-tools/`, tool);
  }

  updateWorkTool(id: number, tool: WorkToolRequest): Observable<WorkTool> {
    return this.http.put<WorkTool>(`${this.API_URL}v1/work-tools/${id}`, tool);
  }

  deleteWorkTool(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}v1/work-tools/${id}`);
  }

  toggleWorkToolActivation(id: number): Observable<WorkTool> {
    return this.http.patch<WorkTool>(`${this.API_URL}v1/work-tools/${id}/toggle`, {});
  }

  uploadIcon(id: number, file: File): Observable<WorkTool> {
    const formData = new FormData();
    formData.append('icon', file, file.name);

    return this.http.put<WorkTool>(`${this.API_URL}v1/work-tools/${id}/icon`, formData);
  }
}
